import type { Me } from "@riea-water/contracts";

/**
 * The banner under the top bar (UX-03): in a demo environment the full
 * concept notice; in a real tenant only the parts that apply, which in this
 * build is "synthetic data" while any synthetic records exist and
 * "market responses SIMULATED" while every adapter is simulated.
 */
export function bannerText(me: Me, demo: boolean, adaptersSimulated = true): string | null {
  if (demo)
    return "Concept preview · fictional utility · synthetic data · market responses SIMULATED";
  const parts: string[] = [];
  if (me.hasSyntheticData) parts.push("synthetic data");
  if (adaptersSimulated) parts.push("market responses SIMULATED");
  return parts.length ? parts.join(" · ") : null;
}

export function Banner(props: { me: Me; demo: boolean }) {
  const text = bannerText(props.me, props.demo);
  if (!text) return null;
  return (
    <div className="banner" role="status">
      {text}
    </div>
  );
}
